import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import RecipientForm from '../../../../components/Verifier/RecipientForm'
import ErrorBoundary from '../../../../components/ErrorBoundary';
import Each from '../../../../components/Each';
import { WithInputType } from '../../../../components/Inputs';
import { ALPHA_NUMERIC, EMAIL_CHECK, isNumber, NAME_CHECK, PHONE_CHECK } from '../../../../Utils/helper';
import { BUTTONS } from '../../../../Utils/Strings';
import cogoToast from 'cogo-toast-react-17-fix';
import API from "../../../../ApiConfig";
import { GET_FORM_FIELDS } from '../../../../Utils/constant';
import ReactPortalModal from '../../../../components/ReactPortalModal';
export default function RecipientsDetails({ id, fieldsData, setFieldsData, submitData, setresult, form_id, form_type, verifier_id, issuer_company, templateFields, setTemplateData, recordFound, submitTrigger, setIsFormValid, DataSearch, setIsDataSearch , setRecordFound}) {

    const [loading, setLoading] = useState(false)
    const [issuerDetailsPopup, setIssuerDetailsPopup]=useState(false)

    const issuermsg=issuer_company=="Birlasoft Limited"?"KPIT was formed on 1st Jan 2019. Hence any KPIT employee having LWD till 1st Jan 2019 will be considered as Birlasoft employee and we will be able to verify the details. However any KPIT member having LWD 2nd Jan or beyond will fall under New KPIT and will have to get the details verified from KPIT": issuer_company=="IGT Solutions Pvt. Limited"?`<div class="popup-message">
    
    <h3>
        The portal comprises data for the below-mentioned entities. 
        Please note that <strong>IGT is now Attain</strong>.
    </h3>

    <ul>
        <li>Interglobe Technologies Private Limited</li>
        <li>Interglobe Technologies International Pvt. Ltd.</li>
        <li>IGT Solutions Pvt. Ltd.</li>
        <li>IGT Dubai (FZ LLC)</li>
    </ul>

    <div>
        If a verifier conducts a search for <strong>IGT Solutions Pvt. Limited</strong> on the portal, this information should be considered applicable to the above-mentioned entities.
    </div>
</div>`:""
    const issuerDetails=issuermsg
    useEffect(() => {
        getFormFields()
    }, [issuer_company])


    const isFirstSubmitTrigger = useRef(true)

    useEffect(()=>{
        if (isFirstSubmitTrigger.current) {
            isFirstSubmitTrigger.current = false
            return
        }
        if (validateFields()) {
            setIsFormValid(true)
        }
    },[submitTrigger])

    function getFormFields() {
        API.get(GET_FORM_FIELDS ,{
            params:{
                verifier_id: verifier_id,
                form_id: form_id,
                form_type: form_type
            }
        })
        .then(res => {
            if(res.data.status === 200){
                let fields = res?.data?.data;
                if (issuer_company === "Walmart Global Technology Services India Private Limited") {
                    const exists = fields.some(f => f.field_name === "gts_id");

                if (!exists) {
                    fields = [
                        ...fields,
                        {
                            field_name: "gts_id",
                            label: "GTS ID",
                            placeholder: "GTS1234567",
                            value: "",
                            isRequired: false,
                            validators: "^[A-Za-z0-9]+$",
                            type: "text"
                        }
                    ];
                }
                    fields = fields.map(field => {
                        if (field.field_name === "employee_id") {
                            return { ...field, label: "WIN ID", placeholder:"123456789", isRequired:false, minLength:9,maxlength:9 };
                        }
                        return field;
                    });
                }
                else if(issuer_company==="Birlasoft Limited" || issuer_company==="IGT Solutions Pvt. Limited") {
                    setIssuerDetailsPopup(true)
                }
    
                setFieldsData(fields);
            }            
        })
        .catch(err => {
            console.log(err);
        })
    }

    // useEffect(() => {
    //     getFormFields();
    // }, [issuer_company])

    // const submitData = () => {
    //     let APIData = {
    //         "verifier_id": id, // add verifier ID
    //         "form_id": form.id
    //     }
    //     if (list.length > 0) {
    //         setLoading(true)
    //         API.post(SEND_REQUEST_VERIFICATION, APIData)
    //             .then(res => {
    //                 cogoToast.success('Notification sent to ' + list.length + ' Recipients')
    //                 navigate('../forms/myRequests')
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //                 cogoToast.error(MESSAGE.DEFAULT_ERROR_MESSAGE)
    //             }).finally(() => setLoading(false))
    //     }
    //     else {
    //         cogoToast.error(MESSAGE.NO_DATA_TO_SAVE)
    //     }

    // }

    // const sendRequest = () => {
    //     return (
    //         <div style={{ display: 'flex', gap: '1rem', width: '20.7rem' }}>
    //             <button className='btn' onClick={() => navigate('../forms/selectForms')}>{BUTTONS.CANCEL}
    //             </button>
    //             <button className='btn btn-primary' onClick={submitData}>
    //                 {loading ? <BtnLoader label={BUTTONS.SEND_REQUEST} /> : BUTTONS.SEND_REQUEST}
    //             </button>
    //         </div>
    //     )
    // }

    function handleFormChange(value, index) {
        let temp = _.cloneDeep(fieldsData)
        temp[index].value = value
        if (temp[index].type === 'number') {
            if (value.length > 0 && !isNumber(value))
                temp[index].error = 'Enter valid input'
            else {
                delete temp[index].error
                if (value.length > 0)
                    temp[index].value = parseInt(value)
            }
        }
        else {
            if (value.length > 0)
                delete temp[index].error
        }
        if (value.length === 0 && !temp[index].isRequired) {
            delete temp[index].error
        }
        setFieldsData(temp)
    }
    const handleTemplateFormChange=(value, index)=>{
        let temp = _.cloneDeep(templateFields)
        temp[index].value = value
        if (temp[index].type === 'number') {
            if (value.length > 0 && !isNumber(value))
                temp[index].error = 'Enter valid input'
            else {
                delete temp[index].error
                if (value.length > 0)
                    temp[index].value = parseInt(value)
            }
        }
        else {
            if (value.length > 0)
                delete temp[index].error
        }
        if (value.length === 0 && !temp[index].is_required) {
            delete temp[index].error
        }
        setTemplateData(temp)
    }
    
    function validateFields() {
        let data = fieldsData
        let isValid = true
        let temp = []
        data.forEach(item => {
            const regex = new RegExp(item.validators)
            let value = item.value ? item.value.toString().trim() : ""
            item.value=value
            if (item.error)
                isValid = false
            if(item.isRequired){
            if (value != undefined || value != null || value == '') {
                if (item.isRequired && value.length === 0) {
                    isValid = false
                    item.error = "*Required!"
                }
            }
            if (!regex.test(value)) {
                isValid = false
                item.error = "*Invalid Data!"
            }}
            temp.push(item)
        })
        setFieldsData(temp)

        if (recordFound==false) {
            let templateValid = true
            let tempTemplate = []

            templateFields.forEach(item => {
                const regex = new RegExp(item.validators)
                let value = item.value ? item.value.toString().trim() : ""
                item.value = value
                if (item.error)
                    templateValid = false

                if (item.isRequired) {
                    if (value != undefined || value != null || value == '') {
                        if (item.isRequired && value.length === 0) {
                            templateValid = false
                            item.error = "*Required!"
                        }
                    }
                    if (!regex.test(value)) {
                        templateValid = false
                        item.error = "*Invalid Data!"
                    }
                }

                tempTemplate.push(item)
            })

            setTemplateData(tempTemplate)
            isValid = isValid && templateValid
        }
        if (!isValid) {
            cogoToast.error('Please Enter valid inputs!')
            return false
        }
        return true
    }

    function handleSearch() {
        if (validateFields()) {
            submitData()
        }
    }

    function resetForm() {
        getFormFields()
        setresult(null)
        setTemplateData(null)
        setIsDataSearch(false)
        setRecordFound(true)
    }
    const IssuerDetails=()=>{
        return (
            <div className="IssuerDetailsBox" dangerouslySetInnerHTML={{ __html: issuerDetails }}/>
        )
    }
    return (
        <section className="recipient-form">
            {issuer_company === "Walmart Global Technology Services India Private Limited" &&    <div style={{margin:"15px", color:"red"}}>Enter Win id of 9 digits, else it will not be responded from our end and no refund will be shared against the same!</div>}
            <div className='row'>
                <Each of={fieldsData} render={(item, index) => {
                    return <div className='col-4 p-1 pt-1 pb-0' key={index}>
                        <WithInputType {...item} onChange={e => handleFormChange(e, index)} />
                    </div>
                }} />
            </div>
        {templateFields &&    <div className='row'>
                <Each of={templateFields} render={(item, index) => {
                    return <div className='col-4 p-1 pt-1 pb-0' key={index}>
                        <WithInputType {...item} onChange={e => handleTemplateFormChange(e, index)} />
                    </div>
                }} />
            </div>}
        <div className='row'>
                <div className='col pl-1'>
                    <button className='btn' onClick={e => resetForm()}>Reset</button>
                {!DataSearch &&    <button className='btn btn-primary' disabled={loading} onClick={handleSearch} style={{ width: "fit-content" }}>
                        {loading ? <BtnLoader label={BUTTONS.CONTINUE} /> : BUTTONS.CONTINUE}
                    </button>}
                </div>
            </div>

            <ReactPortalModal isOpen={issuerDetailsPopup} onClose={()=>setIssuerDetailsPopup(false)} title={"Search Conditions"}>
            <IssuerDetails/>
            </ReactPortalModal>
        </section>
    )
}
